<template>
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">
    <van-nav-bar
      :title="pointName"
      id="topbar"
      left-text="返回"
      @click-left="back"
      style="background-color: #4263EB"
    >
      <template #right>
        <span>{{ paperTrueCount }}/{{ paperCount }}</span>
      </template>
    </van-nav-bar>
    <button
      v-if="currentLocationSignInEnabled"
      class="location-sign-btn"
      type="button"
      @click="openLocationSignIn"
    >
      <van-icon name="location" size="27PX" color="#ffffff"/>
      <span v-if="missingLocationSignInCount" class="location-sign-badge">{{ missingLocationSignInCount }}</span>
    </button>
    <div>
      <div v-if="isHeader" class="card-header bg-transparent">
        <h4 class="question-title">{{ questionName }}</h4>
      </div>
      <div class="card-body">
        <el-form ref="formValidate" :model="formValidate" :rules="ruleValidate" label-position="top">
          <van-tabs v-model="tabsIndex" @change="tabsChange" style="position: fixed;top: 40px;z-index: 444;width: 100%"
                    :animated="true" swipeable :ellipsis="false">

            <van-tab v-for="(group, groupIndex) in currentGroupList"
                     v-if="isGroupList"
                     :key="groupIndex"
                     :name="'tab_' + groupIndex"
                     style="width: 100%;margin: 0px auto;background-color: white;"
            >
              <template #title>
                {{ group.classifyName }}
              </template>


            </van-tab>

            <van-tab name="tab_wfl" v-if="isGroupList" style="width: 90%;margin: 0px auto;background-color: white">
              <template #title>未分类</template>


            </van-tab>

          </van-tabs>

          <div style="margin-top: 30px"></div>

          <div class="card-scroll-box tab-box" :style="{height: cardScrollHeight}"
               v-for="(group, groupIndex) in currentGroupList"
               v-show="isGroupList&&tabsIndex==='tab_'+groupIndex"
               :key="groupIndex"
               style="width: 100%;margin: 0px auto;"
          >
            <div class="paper-box" v-for="(paper, i) in group.paperList" :id="'paper_'+paper.id" :key="paper.id"
                 v-if="paperLogic['logic_' + paper.id]">
              <el-form-item
                :prop="'PAPER_' + paper.id">
                <template #label>

                  <div >


                    <div style="width: 95%;">
                      <span style="font-size: 18px;padding: 2px 2px 2px 15px;background-color:#F5F7FE;border-radius: 5px ">
                        {{paper.paperNum}}
                      </span>
                      <span
                        style="font-size: 18px;font-weight: bold;font-family: PingFang SC;">{{ paper.subjectName }}
                      </span>
                      <img :src="assistUrl" style="width: 20px;height: 20px;margin-top: 6px" @click="addRemark(paper.id)" />
<!--                      <van-icon name="warning-o" size="18" @click="addRemark(paper.id)"/>-->
                    </div>
                  </div>

                </template>
                <!-- 单选 -->
                <el-radio-group v-if="paper.subjectType === 'PAPER_TYPE_SINGLE'"
                                v-model="formValidate['PAPER_' + paper.id].data"
                                vertical
                                @input="paperChange(paper, $event)">
                  <el-radio :disabled="flag===2?true:false" v-for="(option, index) in paper.options"
                            :key="index"
                            :label="option.id">
                    {{ option.optionText }}
                  </el-radio>
                </el-radio-group>
                <!-- 多选 -->
                <el-checkbox-group v-if="paper.subjectType === 'PAPER_TYPE_MULTIPLE'"
                                   v-model="formValidate['PAPER_' + paper.id].data"
                                   vertical
                                   @change="paperChangeDX(paper, $event)">
                  <el-checkbox :disabled="flag===2?true:false" v-for="(option, index) in paper.options" :key="index"
                               :label="option.id">
                    {{ option.optionText }}
                  </el-checkbox>
                </el-checkbox-group>
                <!-- 数值填空 -->
                <div v-if="paper.subjectType === 'PAPER_TYPE_NUMBER_COMPLETION'">

                                        <span v-for="(option, index) in paper.options" :key="index"
                                              style="font-size: 20px">
                                            <div style="width: 100%;">
                                              <div style="float: left;font-size: 16px;width: 40%;line-height: 25px">
                                                {{ option.vacantName }}
                                              </div>
                                              <div style="float: left;width: 50%;line-height: 11px">
                                                <el-input :disabled="flag===2?true:false" type="number"
                                                          @change="paperChangeSZTK(paper,$event)"
                                                          v-model="formValidate['PAPER_' + paper.id].data[index]"></el-input>
                                              </div>
                                            </div>
                                        </span>
                </div>
                <!--     填空          -->
                <el-input v-if="paper.subjectType === 'PAPER_TYPE_TEXT_COMPLETION'"
                       v-model="formValidate['PAPER_' + paper.id].data"
                       type="textarea"
                      :disabled="flag===2?true:false"
                       :autosize="true"
                       maxlength="200"
                      @change="paperChangeDX(paper, $event)"
                       placeholder="请输入内容">
                </el-input>
                <!-- 矩阵 -->
                <!--                <div v-if="paper.subjectType === 'PAPER_TYPE_MATRIX'" class="table-responsive-md">
                                  <table class="table table-bordered table-sm">
                                    <thead class="thead-light">
                                    <tr>
                                      <th scope="col" style="font-size:10px">#</th>
                                      <th scope="col" v-for="(column, columnIndex) in paper.columns" :key="columnIndex"
                                          style="font-size:10px">
                                        {{ column.name }}
                                      </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(row, rowIndex) in paper.rows" :key="rowIndex">
                                      <th scope="row" style="font-size:10px">{{ row.name }}</th>
                                      <td v-for="(column, columnIndex) in paper.columns" :key="columnIndex">
                                        <el-checkbox style="text-align: center;margin-left:0px" @change="paperChangeJZ(paper, $event)"
                                                     :disabled="flag===2?true:false"
                                                     v-model="formValidate['PAPER_' + paper.id].data[rowIndex][columnIndex]"></el-checkbox>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>-->
                <div v-if="paper.subjectType === 'PAPER_TYPE_MATRIX'" class="table-responsive-md">
                  <table class="table-bordered">
                    <thead class="thead-light">
                    <tr>
                      <th scope="col" style="font-size:16px;text-align: center;width: 10%">#</th>
                      <th scope="col" v-for="(column, columnIndex) in paper.columns" :key="columnIndex"
                          style="font-size:16px;text-align: center;width: 10%">
                        {{ column.name }}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, rowIndex) in paper.rows" :key="rowIndex">
                      <th scope="row" style="font-size:16px;text-align: center;line-height: 50px;">{{ row.name }}</th>
                      <td v-for="(column, columnIndex) in paper.columns" :key="columnIndex" style="text-align: center">
                        <el-radio :label="true" style="text-align: center;margin-left:0px"
                                  @change="paperChangeJZ(paper, $event)"
                                  :disabled="flag===2?true:false"
                                  @input="rowCheckedChange(paper,formValidate['PAPER_' + paper.id],rowIndex, columnIndex, $event)"
                                  v-model="formValidate['PAPER_' + paper.id].data[rowIndex][columnIndex]">&nbsp;
                        </el-radio>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </el-form-item>

              <div style="width: 96%;margin: 0px auto;margin-bottom: 30px;">


                <input type="file" :ref="'fileVideoRef'+paper.id" @change="videoChange" accept="video/*" v-show="false"
                />
                <input type="file" :ref="'fileImageRef'+paper.id" @change="imageChange" accept="image/*" v-show="false"
                       multiple
                />

                <div style="width: 100%;height: 30px"
                     v-if="paper.isPicture === '1'&&flag!==2">
                  <div style="height: 100%;width: 40%;float:left;margin-left: 3%;text-align: center;" v-show="false"
                       v-if="formValidate['PAPER_' + paper.id].videos.length<10&&flag!==2">
                    <!--                      <el-button type="success" size="mini" round @click="showVideo(paper.id)" style="font-size: 14px;border-radius: 5px">上传视频</el-button>-->
                    <van-icon name="video-o" color="#4263EB" size="20" style="position: relative;top: 5px"/>
                    <a style="font-size: 14px;color: #4263EB" @click="showVideo(paper.id)">上传视频</a>
                  </div>
                  <div style="height: 100%;width: 40%;float:left;margin-left: 3%;"
                       v-if="formValidate['PAPER_' + paper.id].images.length<50&&flag!==2">
                    <!--                      <el-button type="success" size="mini" round @click="showImage(paper.id)" style="font-size: 14px;border-radius: 5px">上传图片</el-button>-->
                    <van-icon name="photo-o" color="#4263EB" size="20" style="position: relative;top: 5px"/>
                    <a v-show="imageLoadingShow" style="font-size: 14px;color: #4263EB" >上传图片</a>
                    <a v-show="!imageLoadingShow" style="font-size: 14px;color: #4263EB" @click="showImage(paper.id)">上传图片</a>
                  </div>
                </div>
                <div style="width: 95%;margin-top: 30px;"
                     v-if="paper.isPicture === '1'">


                  <div style="width: 100%;border: 0px solid;display: flex;flex-flow: wrap;">
                    <div style="width: 50px;height: 50px;border: 0px solid;margin-left: 10px;margin-top: 10px"
                         v-for="(item,index) in formValidate['PAPER_' + paper.id].images">
                      <van-icon name="close" style="position: absolute;margin-left: 40px;margin-top: -10px;z-index: 2"
                                size="15" color="red" @click="deleteImageFile('PAPER_' + paper.id,index)"
                                v-if="flag!=2"/>
                      <van-image :src="baseApi+'/'+item" style="width: 100%;height: 100%;z-index: 1" :key="item"
                                 @click="showImagePerview('PAPER_' + paper.id,index)"/>
                    </div>
                  </div>

                  <div style="width: 100%;border: 0px solid;display: flex;flex-flow: wrap;">
                    <div style="width: 50px;height: 50px;border: 0px solid;margin-left: 10px;margin-top: 10px"
                         v-for="(item,index) in formValidate['PAPER_' + paper.id].videos">
                      <van-icon name="close" style="position: absolute;margin-left: 40px;margin-top: -10px;z-index: 2"
                                size="15" color="red" @click="deleteVideoFile('PAPER_' + paper.id,index)"
                                v-if="flag!=2"/>
                      <van-image :src="videoImage" style="width: 100%;height: 100%;z-index: 1" :key="item"
                                 @click="showVideoPerview('PAPER_' + paper.id,item)"/>
                    </div>
                  </div>

                </div>

                <textarea type="text" v-show="formValidate['PAPER_' + paper.id].descriptionShow"
                          v-model="formValidate['PAPER_' + paper.id].description"
                          :disabled="flag===2?true:false"
                          placeholder="请填写说明"
                          style="color: #A2A0A8;background-color:#F5F7FE;border: 0px solid;font-size: 14px;width: 100%;height: 100px;padding: 10px 10px 10px 10px;border-radius: 10px;margin-top: 10px"
                />

              </div>

            </div>
          </div>


          <div class="card-scroll-box tab-box" :style="{height: cardScrollHeight}"
               v-show="isGroupList&&tabsIndex==='tab_wfl'"
               style="width: 90%;margin: 0px auto;"
          >
            <div class="paper-box1" v-for="(paper, i) in surplusPaperList" :id="'paper_'+paper.id" :key="paper.id"
                 v-if="paperLogic['logic_' + paper.id]">
              <el-form-item
                :prop="'PAPER_' + paper.id">
                <template #label>

                  <div >


                    <div style="width: 95%;">
                      <span style="font-size: 18px;padding: 2px 2px 2px 15px;background-color:#F5F7FE;border-radius: 5px ">
                        {{paper.paperNum}}
                      </span>
                      <span
                        style="font-size: 18px;font-weight: bold;font-family: PingFang SC;">{{ paper.subjectName }}
                      </span>
                      <img :src="assistUrl" style="width: 20px;height: 20px;margin-top: 6px" @click="addRemark(paper.id)" />
                      <!--                      <van-icon name="warning-o" size="18" @click="addRemark(paper.id)"/>-->
                    </div>
                  </div>

                </template>
                <!-- 单选 -->
                <el-radio-group v-if="paper.subjectType === 'PAPER_TYPE_SINGLE'"
                                v-model="formValidate['PAPER_' + paper.id].data"
                                vertical
                                @input="paperChange(paper, $event)">
                  <el-radio :disabled="flag===2?true:false" v-for="(option, index) in paper.options"
                            :key="index"
                            :label="option.id">
                    {{ option.optionText }}
                  </el-radio>
                </el-radio-group>
                <!-- 多选 -->
                <el-checkbox-group v-if="paper.subjectType === 'PAPER_TYPE_MULTIPLE'"
                                   v-model="formValidate['PAPER_' + paper.id].data"
                                   vertical
                                   @change="paperChangeDX(paper, $event)">
                  <el-checkbox :disabled="flag===2?true:false" v-for="(option, index) in paper.options" :key="index"
                               :label="option.id">
                    {{ option.optionText }}
                  </el-checkbox>
                </el-checkbox-group>
                <!-- 数值填空 -->
                <div v-if="paper.subjectType === 'PAPER_TYPE_NUMBER_COMPLETION'">

                                        <span v-for="(option, index) in paper.options" :key="index"
                                              style="font-size: 20px">
                                            <div style="width: 100%;">
                                              <div style="float: left;font-size: 16px;width: 40%;line-height: 25px">
                                                {{ option.vacantName }}
                                              </div>
                                              <div style="float: left;width: 50%;line-height: 11px">
                                                <el-input :disabled="flag===2?true:false" type="number"
                                                          @change="paperChangeSZTK(paper,$event)"
                                                          v-model="formValidate['PAPER_' + paper.id].data[index]"></el-input>
                                              </div>
                                            </div>
                                        </span>
                </div>




                  <el-input v-if="paper.subjectType === 'PAPER_TYPE_TEXT_COMPLETION'"
                            v-model="formValidate['PAPER_' + paper.id].data"
                            type="textarea"
                            :disabled="flag===2?true:false"
                            :autosize="true"
                            maxlength="200"
                            @change="paperChangeDX(paper, $event)"
                            placeholder="请输入内容">
                  </el-input>

                <!-- 矩阵 -->
                <!--                <div v-if="paper.subjectType === 'PAPER_TYPE_MATRIX'" class="table-responsive-md">
                                  <table class="table table-bordered table-sm">
                                    <thead class="thead-light">
                                    <tr>
                                      <th scope="col" style="font-size:10px">#</th>
                                      <th scope="col" v-for="(column, columnIndex) in paper.columns" :key="columnIndex"
                                          style="font-size:10px">
                                        {{ column.name }}
                                      </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(row, rowIndex) in paper.rows" :key="rowIndex">
                                      <th scope="row" style="font-size:10px">{{ row.name }}</th>
                                      <td v-for="(column, columnIndex) in paper.columns" :key="columnIndex">
                                        <el-checkbox style="text-align: center;margin-left:0px" @change="paperChangeJZ(paper, $event)"
                                                     :disabled="flag===2?true:false"
                                                     v-model="formValidate['PAPER_' + paper.id].data[rowIndex][columnIndex]"></el-checkbox>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>-->
                <div v-if="paper.subjectType === 'PAPER_TYPE_MATRIX'" class="table-responsive-md">
                  <table class="table-bordered">
                    <thead class="thead-light">
                    <tr>
                      <th scope="col" style="font-size:16px;text-align: center;width: 10%">#</th>
                      <th scope="col" v-for="(column, columnIndex) in paper.columns" :key="columnIndex"
                          style="font-size:16px;text-align: center;width: 10%">
                        {{ column.name }}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, rowIndex) in paper.rows" :key="rowIndex">
                      <th scope="row" style="font-size:16px;text-align: center;line-height: 50px">{{ row.name }}</th>
                      <td v-for="(column, columnIndex) in paper.columns" :key="columnIndex" style="text-align: center">
                        <el-radio :label="true" style="text-align: center;margin-left:0px"
                                  @change="paperChangeJZ(paper, $event)"
                                  :disabled="flag===2?true:false"
                                  @input="rowCheckedChange(paper,formValidate['PAPER_' + paper.id],rowIndex, columnIndex, $event)"
                                  v-model="formValidate['PAPER_' + paper.id].data[rowIndex][columnIndex]">&nbsp;
                        </el-radio>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </el-form-item>
              <div style="width: 96%;margin: 0px auto;margin-bottom: 30px;">


                <input type="file" :ref="'fileVideoRef'+paper.id" @change="videoChange" accept="video/*" v-show="false"
                />
                <input type="file" :ref="'fileImageRef'+paper.id" @change="imageChange" accept="image/*" v-show="false"
                       multiple
                />

                <div style="width: 100%;height: 30px"
                     v-if="paper.isPicture === '1'&&flag!==2">
                  <div style="height: 100%;width: 40%;float:left;margin-left: 3%;text-align: center;" v-show="false"
                       v-if="formValidate['PAPER_' + paper.id].videos.length<10&&flag!==2">
                    <!--                      <el-button type="success" size="mini" round @click="showVideo(paper.id)" style="font-size: 14px;border-radius: 5px">上传视频</el-button>-->
                    <van-icon name="video-o" color="#4263EB" size="20" style="position: relative;top: 5px"/>
                    <a style="font-size: 14px;color: #4263EB" @click="showVideo(paper.id)">上传视频</a>
                  </div>
                  <div style="height: 100%;width: 40%;float:left;margin-left: 3%;"
                       v-if="formValidate['PAPER_' + paper.id].images.length<50&&flag!==2">
                    <!--                      <el-button type="success" size="mini" round @click="showImage(paper.id)" style="font-size: 14px;border-radius: 5px">上传图片</el-button>-->
                    <van-icon name="photo-o" color="#4263EB" size="20" style="position: relative;top: 5px"/>
                    <a v-show="imageLoadingShow" style="font-size: 14px;color: #4263EB" >上传图片</a>
                    <a v-show="!imageLoadingShow" style="font-size: 14px;color: #4263EB" @click="showImage(paper.id)">上传图片</a>
                  </div>
                </div>
                <div style="width: 95%;margin-top: 30px;"
                     v-if="paper.isPicture === '1'">


                  <div style="width: 100%;border: 0px solid;display: flex;flex-flow: wrap;">
                    <div style="width: 50px;height: 50px;border: 0px solid;margin-left: 10px;margin-top: 10px"
                         v-for="(item,index) in formValidate['PAPER_' + paper.id].images">
                      <van-icon name="close" style="position: absolute;margin-left: 40px;margin-top: -10px;z-index: 2"
                                size="15" color="red" @click="deleteImageFile('PAPER_' + paper.id,index)"
                                v-if="flag!=2"/>
                      <van-image :src="baseApi+'/'+item" style="width: 100%;height: 100%;z-index: 1" :key="item"
                                 @click="showImagePerview('PAPER_' + paper.id,index)"/>
                    </div>
                  </div>

                  <div style="width: 100%;border: 0px solid;display: flex;flex-flow: wrap;">
                    <div style="width: 50px;height: 50px;border: 0px solid;margin-left: 10px;margin-top: 10px"
                         v-for="(item,index) in formValidate['PAPER_' + paper.id].videos">
                      <van-icon name="close" style="position: absolute;margin-left: 40px;margin-top: -10px;z-index: 2"
                                size="15" color="red" @click="deleteVideoFile('PAPER_' + paper.id,index)"
                                v-if="flag!=2"/>
                      <van-image :src="videoImage" style="width: 100%;height: 100%;z-index: 1" :key="item"
                                 @click="showVideoPerview('PAPER_' + paper.id,item)"/>
                    </div>
                  </div>

                </div>

                <textarea type="text" v-show="formValidate['PAPER_' + paper.id].descriptionShow"
                          v-model="formValidate['PAPER_' + paper.id].description"
                          :disabled="flag===2?true:false"
                          placeholder="请填写说明"
                          style="color: #A2A0A8;background-color:#F5F7FE;border: 0px solid;font-size: 14px;width: 100%;height: 100px;padding: 10px 10px 10px 10px;border-radius: 10px;margin-top: 10px"
                />

              </div>


            </div>

          </div>


        </el-form>

      </div>
    </div>
    <br>
    <br>
    <img :src="cupUrl" style="z-index: 999;position: fixed;bottom: 200px;right: 0px"
              @click="show1=true" v-if="type===4" />

    <img :src="paperCardUrl" style="z-index: 999;position: fixed;bottom: 140px;right: 0px"
              @click="showModal" v-if="!show"/>
<!--    <van-icon :name="!show7?'arrow-up':'arrow-down'" color="#4263EB" style="z-index: 999;position: fixed;bottom: 100px;right: 0px"
              @click="show7=!show7" v-if="flag!==2" />-->

<!--    <img src="../../../assets/back-top.png" style="width: 40px;height: 40px;position: fixed;bottom: 250px;right: 0px"
         @click="backTop"/>-->


    <van-popup v-model="show2" position="bottom" closeable :style="{ height: '100%' }" close-icon-position="top-right"
               style="z-index: 99999">
      <video v-if="show2" style="height: 100%;width: 100%" class="video-js vjs-default-skin" autoplay controls
             preload="none" x5-playsinline="" webkit-playsinline="" playsinline="" poster="" x-webkit-airplay="allow">
        <source :src="videoUrl" type="video/mp4">
        <object :data="videoUrl">
          <embed :src="videoUrl">
        </object>
      </video>
    </van-popup>

    <van-popup v-model="show" position="bottom" closeable :style="{ height: '65%' }" close-icon-position="top-right"
               style="z-index: 99999">
      <div style="text-align: center">
        <span style="font-size: 20px;font-weight: bold">完成情况</span>
      </div>
      <div v-if="flag===1"
        style="border: 0px solid;width: 350px;margin: 0px auto;padding: 40px 15px 15px 15px;height: 400px;">
        <div v-if="paperLogic['logic_' + paper.id]" @click="toPaper(paper.id,i)"
             :class="paperTrue['paper'+paper.id]===true?'paper-true':'paper-false'"
             :style="{border: '0px'}"
             style="width: 70px;height: 70px;border: 1px solid;border-radius: 50%;margin-top: 10px;line-height: 70px;text-align: center;margin-left: 2%;font-size: 20px;float: left"
             v-for="(paper, i) in paperList" :key="i">
          {{ paper.paperNum }}
        </div>
      </div>
      <div v-if="flag!==1"
           style="border: 0px solid;width: 350px;margin: 0px auto;padding: 40px 15px 15px 15px;height: 400px;">
        <div v-if="paperLogic['logic_' + paper.id]" @click="toPaper(paper.id,i)"
             :class="paperTrue['paper'+paper.id]===true?'paper-true1':'paper-false1'"
             :style="{border: '0px', color: answerData['PAPER_'+paper.id].paperState==='state_false' ? paperTrue['paper'+paper.id]===true?'#000':'#fff' :'#fff',
             backgroundColor: answerData['PAPER_'+paper.id].paperState==='state_true'? paperTrue['paper'+paper.id]===true?'#07C160':'red' : answerData['PAPER_'+paper.id].paperState==='state_false'? paperTrue['paper'+paper.id]===true?'yellow':'red' : paperTrue['paper'+paper.id]===true?'#07C160':'red' }"
             style="width: 70px;height: 70px;border: 1px solid;border-radius: 50%;margin-top: 10px;line-height: 70px;text-align: center;margin-left: 2%;font-size: 20px;float: left"
             v-for="(paper, i) in paperList" :key="i">
          {{ paper.paperNum }}
        </div>
      </div>
      <br>
    </van-popup>


    <van-popup v-model="show1" position="bottom" :style="{ height: '60%' }" style="z-index: 99999">
      <computer/>
    </van-popup>
    <van-popup v-model="show3" position="bottom" closeable :style="{ height: '55%' }" close-icon-position="top-right"
               style="z-index: 99999">
      <div style="width: 200px;margin: 0px auto;text-align: center;">
        <span style="font-size: 20px;font-weight: bold">申请修改</span>
      </div>
      <br>
      <div style="height: 200px;overflow: auto">
        <van-field
          v-model="message"
          rows="2"
          autosize
          label="申请理由："
          type="textarea"
          maxlength="200"
          placeholder="请输入申请理由"
          show-word-limit
          style="font-size: 16px"
        />
      </div>
      <div style="height: 40px;width: 200px;margin: auto">
        <el-button type="primary" size="mini" round style="border-radius: 6px;background: #F5F7FE;color: #4263EB"
                   @click="updateReview">提交申请
        </el-button>
      </div>
    </van-popup>
    <van-popup v-model="show4" position="bottom" closeable :style="{ height: '17%' }" close-icon-position="top-right">
      <br>
      <div style="text-align: center">
        <audio autoplay controls>
          <source :src="baseApi+'/'+recordingId" type="audio/amr">
          <source :src="baseApi+'/'+recordingId" type="audio/m4a">
          <source :src="baseApi+'/'+recordingId" type="audio/mp3">
          <source :src="baseApi+'/'+recordingId" type="audio/mpeg">
          <embed height="50" width="50" :src="baseApi+'/'+recordingId">
        </audio>
      </div>
    </van-popup>

    <van-popup v-model="show5" position="bottom" closeable
               :style="{ height: 2+(this.recordingId.split(',').length)+'0%' }" close-icon-position="top-right">
      <div style="text-align: center;font-size: 20px;font-weight: bold;padding: 20px">
        录音数据
      </div>
      <div style="text-align: center" v-for="(item,index) in recordingId.split(',')" :key="index" v-if="item!==''">

        <div style="height: 60px;width: 85%;float: left" v-if="!recordingLoadingShow&&flag!=2">
          <audio controls v-if="!recordingLoadingShow" :key="item">
            <source :src="baseApi+'/'+item" type="audio/amr">
            <source :src="baseApi+'/'+item" type="audio/m4a">
            <source :src="baseApi+'/'+item" type="audio/mp3">
            <source :src="baseApi+'/'+item" type="audio/mpeg">
            <embed height="50" width="50" :src="baseApi+'/'+item">
          </audio>
        </div>
        <div style="height: 60px;width: 100%;float: left" v-if="!recordingLoadingShow&&flag==2">
          <audio controls v-if="!recordingLoadingShow" :key="item">
            <source :src="baseApi+'/'+item" type="audio/amr">
            <source :src="baseApi+'/'+item" type="audio/m4a">
            <source :src="baseApi+'/'+item" type="audio/mp3">
            <source :src="baseApi+'/'+item" type="audio/mpeg">
            <embed height="50" width="50" :src="baseApi+'/'+item">
          </audio>
        </div>
        <div style="height: 60px;width: 5%;float: left;margin-right: 10%;line-height: 60px" v-if="flag!=2">
          <van-icon name="close" size="30" color="red" @click="removeAudio(index)" v-if="!recordingLoadingShow"/>
        </div>

      </div>
      <div style="margin: 0px auto;width: 100%;text-align: center;height: 40px" v-if="flag!=2">
        <div style="width: 50%;float: left;height: 40px;margin-left: 25%">
          <el-button type="primary" size="mini" round style="border-radius: 6px;background: #F5F7FE;color: #4263EB"
                     @click="clickAudio">上传录音
          </el-button>
        </div>

      </div>
    </van-popup>
    <van-popup v-model="show6" position="bottom" closeable
               :style="{ height: 2+(this.tempRecordingId.split(',').length)+'0%' }" close-icon-position="top-right">
      <div style="text-align: center;font-size: 20px;font-weight: bold;padding: 20px">
        补传录音数据
      </div>
      <div style="text-align: center" v-for="(item,index) in tempRecordingId.split(',')" :key="index" v-if="item!==''">

        <div style="height: 60px;width: 90%;float: left">
          <audio controls v-if="!recordingLoadingShow" :key="item">
            <source :src="baseApi+'/'+item" type="audio/amr">
            <source :src="baseApi+'/'+item" type="audio/m4a">
            <source :src="baseApi+'/'+item" type="audio/mp3">
            <source :src="baseApi+'/'+item" type="audio/mpeg">
            <embed height="50" width="50" :src="baseApi+'/'+item">
          </audio>
        </div>
        <div style="height: 60px;width: 5%;float: left;;line-height: 60px">
          <van-icon name="close" size="30" color="red" @click="removeAudio(index)" v-if="!recordingLoadingShow"/>
        </div>

      </div>
      <div style="margin: 0px auto;width: 100%;text-align: center;height: 40px">
        <div style="width: 40%;float: left;height: 40px;margin-left: 5%">
          <el-button type="primary" size="mini" round style="border-radius: 6px;background: #F5F7FE;color: #4263EB"
                     @click="clickAudio">上传录音
          </el-button>
        </div>

        <div style="width: 40%;float: left;height: 40px;margin-left: 10%">
          <el-button type="primary" size="mini" round style="border-radius: 6px;background: #F5F7FE;color: #4263EB"
                     @click="handleSubmitTempRecordingIds">确定提交
          </el-button>
        </div>

      </div>
    </van-popup>
    <input type="file" ref="audioRef" @change="audioChange" accept="audio/*,.mp3,.m4a,.amr" id="audio-upload"
           v-show="false">
    <div
      style="border: 0px solid red;width: 100%;height: 90px;position: fixed;bottom: 0px;background-color: white;z-index: 20"
      v-if="flag!=2&&show7">
      <div style="width: 90%;height: 100%;margin: 0px auto;margin-left: 5%">
        <div style="border: 0px solid;width: 30%;height: 40px;float: left;margin-top: 10px">
          <el-button type="primary" size="mini" round style="border-radius: 6px;background: #F5F7FE;color: #4263EB"
                     @click="tempSave">保存
          </el-button>
        </div>
        <div style="border: 0px solid;width: 30%;height: 40px;float: left;margin-top: 10px;margin-left: 5%">

          <el-button type="primary" size="mini" round style="border-radius: 6px;background: #F5F7FE;color: #ee0a24;border: 1px solid #ee0a24"
                     @click="clickAudio" v-if="recordingId===''&&!recordingLoadingShow">上传录音
          </el-button>
          <el-button type="primary" size="mini" round style="border-radius: 6px;background: #F5F7FE;color: #4263EB"
                     v-if="recordingLoadingShow">上传中...
          </el-button>
          <el-button type="primary" size="mini"  round style="border-radius: 6px;background: #F5F7FE;color: #07c160;border: 1px solid #07c160"
                     @click="show5 = true" v-if="recordingId!==''&&!recordingLoadingShow">已上传
          </el-button>
        </div>
        <div style="border: 0px solid;width: 30%;height: 40px;float: left;margin-left: 5%;margin-top: 10px">
          <el-button type="primary" size="mini" round @click="handleSubmit"
                     style="border-radius: 6px;background: #4263EB;;color: white">提交
          </el-button>
        </div>
      </div>
    </div>
    <div
      style="border: 0px solid red;width: 100%;height: 90px;position: fixed;bottom: 0px;background-color: white;z-index: 20"
      v-if="flag===2">
      <div style="border: 0px solid;width: 80%;height: 40px;margin: 0px auto;margin-left: 10%">

        <div style="width: 30%;float: left;height: 40px;margin-top: 10px">
          <el-button type="primary" size="mini" round style="border-radius: 6px;background: #F5F7FE;color: #4263EB"
                     @click="show6=true">补传录音
          </el-button>
        </div>
        <div style="width: 30%;float: left;height: 40px;margin-top: 10px;margin-left: 5%">
          <el-button type="primary" size="mini" round style="border-radius: 6px;background: #F5F7FE;color: #4263EB"
                     @click="show5 = true" v-if="recordingId!==''">播放录音
          </el-button>
        </div>
        <div style="width: 30%;float: left;margin-left: 5%;height: 40px;margin-top: 10px">
          <el-button type="primary" size="mini" round style="border-radius: 6px;background: #F5F7FE;color: #4263EB"
                     @click="show3 = true">申请修改
          </el-button>
        </div>


      </div>
    </div>

    <div v-show="imageLoadingShow"
         style="height: 100%;width: 100%;background-color: rgba(0,0,0,0.3);z-index: 99999;position: fixed;top:0px;text-align: center">
      <van-loading type="spinner" color="#1989fa" text-size="14px" style="margin-top: 70%;z-index: 999999" v-if="percentData!==0">
        正在上传中{{percentData+percentDataFlast}}%...
      </van-loading>
      <van-loading type="spinner" color="#1989fa" text-size="14px" style="margin-top: 70%;z-index: 999999" v-if="percentData===0">
        正在上传中{{percentData+percentDataFlast}}%...
      </van-loading>
    </div>

  </div>
  <!--    <div style="height: calc(100vh - 110px);">-->
  <!--        -->
  <!--    </div>-->
</template>
<script>
import _, {each} from 'lodash'
import setting from "@/setting";
import $ from "@/utils/request"
import {upLoadFileCommon, uploadfilecommonAddWaterMarking} from "@/libs/uploadfilecommon";
import vueMiniPlayer from 'vue-mini-player'
import 'video.js/dist/video-js.css'
import videojs from 'video.js'
import {Dialog, ImagePreview, Notify} from 'vant';
import computer from "@/views/feature/paper/computer";
import ImageCompressor from 'image-compressor.js'

export default {
  name: "paper",
  components: {vueMiniPlayer, [ImagePreview.Component.name]: ImagePreview.Component, computer},
  props: {
    cardHeight: {
      type: String,
      default: 'calc(100vh - 78px)'
    },
    cardScrollHeight: {
      type: String,
      default: 'calc(100vh - 195px)'
    },
    index: {
      type: Number,
      default: 0
    },
    pointId: {
      type: Number,
      default: 0
    },
    taskId: {
      type: Number,
      default: 0
    },
    flag: {
      type: Number,
      default: 0
    },
    pointName: {
      type: String,
      default: ''
    },
    projectId: {
      type: [Number, String],
      default: null
    },
    locationSignInGroups: {
      type: Array,
      default: () => []
    },
    locationSignIns: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      baseApi: setting.ossBaseUrl,
      baseUrl: setting.apiBaseURL,
      isHeader: true,
      tabsIndex: 'tab_wfl',
      currentGroupList: [],
      surplusPaperList: [],
      logicList: [],
      paperLogic: [],
      formValidate: {},
      ruleValidate: {},
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      clientHeight: window.screen.height,
      show: false,
      show1: false,
      fileImageData: {},
      fileVideoData: {},
      paperId: '',
      recordingId: '', // 录音文件id,
      answer: false,
      answerData: null,
      taskPointDetailsId: '',
      type: '',
      classIndex: -1,
      paperTrue: {},
      videoImage: require('../../../assets/video.jpg'),
      show2: false,
      videoUrl: '',
      message: '',
      show3: false,
      paperTrueCount: 0,
      paperCount: 0,
      show4: false,
      show5: false,
      show6: false,
      show7: true,
      checkPaperId: '',
      paperList: [],
      recordingLoadingShow: false,
      imageLoadingShow: false,
      tempRecordingId: '',
      audioUploadProgress: '1%',
      intervalData: null,
      uploadProgressId: '',
      percentData: 0,
      percentDataFlast: 0,
      assistUrl: require('@/assets/assist.svg'),
      cupUrl: require('@/assets/cup.svg'),
      paperCardUrl: require('@/assets/paper-card.svg'),
    }
  },
  computed: {
    isShowSurplus() {
      return !!(this.surplusPaperList && this.surplusPaperList.length)
    },
    isGroupList() {
      return !!(this.currentGroupList && this.currentGroupList.length)
    },
    questionName() {
      return this.$store.state.question.name
    },
    locationSignInEnabled() {
      return this.locationSignInGroups && this.locationSignInGroups.length > 0
    },
    missingLocationSignInCount() {
      return this.getMissingLocationSignInGroups().length
    },
    currentLocationSignInGroup() {
      if (!this.tabsIndex || this.tabsIndex === 'tab_wfl') {
        return null
      }
      const index = Number(String(this.tabsIndex).replace('tab_', ''))
      if (Number.isNaN(index)) {
        return null
      }
      return this.currentGroupList[index] || null
    },
    currentLocationSignInEnabled() {
      if (!this.locationSignInEnabled || !this.currentLocationSignInGroup) {
        return false
      }
      if (!this.groupHasVisiblePapers(this.currentLocationSignInGroup)) {
        return false
      }
      const currentGroupId = this.groupId(this.currentLocationSignInGroup)
      return this.locationSignInGroups.some(group => String(this.groupId(group)) === String(currentGroupId))
    }
  },
  methods: {
    groupId(group) {
      return group && group.id !== undefined && group.id !== null ? group.id : group.classifyName
    },
    hasLocationSignIn(group) {
      const groupId = this.groupId(group)
      return (this.locationSignIns || []).some(item => {
        return String(item.groupId) === String(groupId) && item.location
      })
    },
    getMissingLocationSignInGroups() {
      return this.getRequiredVisibleLocationSignInGroups().filter(group => !this.hasLocationSignIn(group))
    },
    getRequiredVisibleLocationSignInGroups() {
      if (!this.locationSignInEnabled) {
        return []
      }
      return this.locationSignInGroups.filter(group => this.groupHasVisiblePapers(group))
    },
    groupHasVisiblePapers(group) {
      const visibleVersion = this.paperTrueCount
      if (visibleVersion < 0) {
        return false
      }
      if (!group || !Array.isArray(group.paperList) || !group.paperList.length) {
        return false
      }
      return group.paperList.some(paper => this.paperLogic['logic_' + paper.id])
    },
    getGroupIndex(group) {
      return this.currentGroupList.findIndex(item => String(this.groupId(item)) === String(this.groupId(group)))
    },
    scrollToGroup(group) {
      const groupIndex = this.getGroupIndex(group)
      if (groupIndex > -1) {
        this.tabsIndex = 'tab_' + groupIndex
      }
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      this.autoOpenLocationSignIn()
    },
    openLocationSignIn() {
      this.$emit('on-location-sign-in', this.formValidate, this.recordingId, this.currentLocationSignInGroup)
    },
    autoOpenLocationSignIn() {
      this.$nextTick(() => {
        const group = this.currentLocationSignInGroup
        if (this.flag === 2 || !this.currentLocationSignInEnabled || !group || this.hasLocationSignIn(group)) {
          return
        }
        this.openLocationSignIn()
      })
    },
    rowCheckedChange(paper, currentValue, rowIndex, columnIndex, $event) {
      const row = currentValue.data[rowIndex]
      row.forEach((column, index) => {
        if (index !== columnIndex) {
          row[index] = false
        }
      })
      this.$refs.formValidate.validateField('PAPER_' + paper.id)
    },
    //暂存(
    tempSave() {
      if (this.recordingLoadingShow) {
        Notify({type: 'warning', message: '正在上传中，请稍后保存'});
        return
      }
      this.$emit('on-tempSave', this.formValidate, this.recordingId)
    },
    //申请修改
    updateReview() {
      console.log('message', this.message)
      let data = {
        taskId: this.taskId,
        pointId: this.pointId,
        message: this.message
      }
      $.put('/mobile/applyUpdate', data).then(res => {
        Notify({type: 'success', message: '提交申请修改成功'});
        this.show3 = false
      }).catch(err => {

      })
    },
    back() {
      if (this.flag === 2) {
        Dialog.confirm({
          title: '确认提示',
          message: '是否返回至我的记录？',
        })
          .then(() => {
            // on confirm
            this.$router.push({name: 'feature-foo'})
          })
          .catch(() => {
            // on cancel
          });


      } else {
        Dialog.confirm({
          title: '确认提示',
          message: '是否返回至我的任务？',
        })
          .then(() => {
            // on confirm
            this.$router.push({name: 'homepage'})
          })
          .catch(() => {
            // on cancel
          });

      }
    },
    removeAudio(index) {

      Dialog.confirm({
        title: '确认提示',
        message: '是否删除当前录音？',
      })
        .then(() => {
          // on confirm
          if (this.flag !== 2) {
            this.recordingLoadingShow = true
            console.log('删除前', this.recordingId)
            const recordingArr = this.recordingId.split(',')
            recordingArr.splice(index, 1)
            this.recordingId = recordingArr.toString()
            console.log('删除后', this.recordingId)
            Notify({type: 'success', message: '删除成功!'});
            if (this.recordingId.split(',').length < 1) {
              this.show5 = false
            }
            this.recordingLoadingShow = false
            this.$emit('auto-on-tempSave', this.formValidate, this.recordingId)
          } else {
            this.recordingLoadingShow = true
            const recordingArr = this.tempRecordingId.split(',')
            recordingArr.splice(index, 1)
            this.tempRecordingId = recordingArr.toString()
            Notify({type: 'success', message: '删除成功!'});
            if (this.tempRecordingId.split(',').length < 1) {
              this.show6 = false
            }
            this.recordingLoadingShow = false
          }
        })
        .catch(() => {
          // on cancel
        });


    },
    clickAudio() {
      this.$refs.audioRef.click()
    },
    //监听链接状态
    uploadProgress(e){
      console.log('uploadProgress',e)
      if (!this.recordingLoadingShow) {
        this.recordingLoadingShow = true
      }
      if (!this.imageLoadingShow) {
        this.imageLoadingShow = true
      }
      if(this.audioFileSize===0){
        this.audioFileSize = e.total
      }
      this.percentData = this.getPercent(e.loaded,e.total,false)/2
      console.log('前端进度',this.percentData)
      if(e.loaded===e.total){
        console.log('前端传输完成',e.loaded)
        const _this = this;
        this.intervalData = setInterval(function (){
          _this.percent()
        },2000)
      }
    },
    getPercent(curNum, totalNum, isHasPercentStr) {
        curNum = parseFloat(curNum);
        totalNum = parseFloat(totalNum);

       if (isNaN(curNum) || isNaN(totalNum)) {
             return '-';
         }

       return isHasPercentStr ?
            totalNum <= 0 ? '0%' : (Math.round(curNum / totalNum * 10000) / 100.00 + '%') :
           totalNum <= 0 ? 0 : (Math.round(curNum / totalNum * 10000) / 100.00);
     },
    percent(){
      $.get('/progress/percent?uploadProgressId='+this.uploadProgressId).then(res=>{
        if(res.data!==0&&res.data!=='0'){
          this.percentDataFlast=res.data/2
        }
        console.log('后端进度',this.percentDataFlast)
        let _this = this;
        if(res.data===100){
          clearInterval(this.intervalData)
          this.percentData = 0
          this.percentDataFlast = 0
        }
      })
    },

    percentReset(){
      $.get('/progress/percent/reset?uploadProgressId='+this.uploadProgressId)
    },
    //链接完成
    uploadComplete(e){
      console.log('uploadComplete',e)
      clearInterval(this.intervalData)
      this.percentData = 0
      this.percentDataFlast = 0
      if (this.flag !== 2) {
        if (this.recordingId !== '') {
          this.recordingId += ',' + e.target.response
        } else {
          this.recordingId = e.target.response
        }
      } else {
        if (this.tempRecordingId !== '') {
          this.tempRecordingId += ',' + e.target.response
        } else {
          this.tempRecordingId = e.target.response
        }
      }
      this.recordingLoadingShow = false
      this.imageLoadingShow = false
      if (this.flag !== 2) {
        this.$emit('auto-on-tempSave', this.formValidate, this.recordingId)
      }
      $.get('/progress/percent/reset?uploadProgressId='+this.uploadProgressId)
      Notify({type:'success',message:'上传成功!'})
    },
    //链接错误
    uploadFailed(e){
      console.log('uploadFailed',e)
      this.recordingLoadingShow = false
      this.imageLoadingShow = false
      Notify({type: 'danger', message: '上传失败!'});
    },
    //链接取消
    uploadCanceled(e){
      console.log('uploadCanceled',e)
    },
    audioChange(t) {

      console.log('t.target.files',t.target.files)
      if(t.target.files.length<1){
        return
      }

      this.uploadProgressId = 'uploadProgress'+Date.now()

      var fd = new FormData();
      fd.append("file", t.target.files[0]);
      fd.append("uploadProgressId",this.uploadProgressId)
      this.audioFileSize = 0

      //船舰XMLHttpRequest对象
      var xhr = new XMLHttpRequest();
      //获取token
      const token = JSON.parse(localStorage.getItem('token'))
      //监听链接传输状态
      xhr.upload.addEventListener("progress", this.uploadProgress, false);
      //链接传输完成
      xhr.addEventListener("load", this.uploadComplete, false);
      //链接错误
      xhr.addEventListener("error", this.uploadFailed, false);
      //链接取消
      xhr.addEventListener("abort", this.uploadCanceled, false);
      //设置请求链接
      xhr.open("POST", this.baseUrl+"/upload");
      //设置超时时间
      xhr.timeout = 10000000
      //设置token
      xhr.setRequestHeader('Authentication',token)
      //设置链接参数
      xhr.send(fd);
      /*if (t.target.files.length > 0) {
        if (!this.recordingLoadingShow) {
          this.recordingLoadingShow = true
        }
        if (!this.imageLoadingShow) {
          this.imageLoadingShow = true
        }
        upLoadFileCommon(t.target.files[0]).then(res => {
          if (this.flag === 1) {
            if (this.recordingId !== '') {
              this.recordingId += ',' + res
            } else {
              this.recordingId = res
            }
          } else {
            if (this.tempRecordingId !== '') {
              this.tempRecordingId += ',' + res
            } else {
              this.tempRecordingId = res
            }
          }


          this.recordingLoadingShow = false
          this.imageLoadingShow = false
          if (this.flag !== 2) {
            this.$emit('auto-on-tempSave', this.formValidate, this.recordingId)
          }
        }).catch(err => {
          this.recordingLoadingShow = false
          Notify({type: 'error', message: '上传失败!'});
        })
      }*/


    },
    toPaper(id, groupIndex) {


      for (let i = 0; i < this.currentGroupList.length; i++) {

        for (let j = 0; j < this.currentGroupList[i].paperList.length; j++) {
          if (id === this.currentGroupList[i].paperList[j].id) {
            groupIndex = i
          }
        }
      }

      for (let i = 0; i < this.surplusPaperList.length; i++) {
        if (id === this.surplusPaperList[i].id) {
          groupIndex = -1
        }
      }
      console.log('id', id)
      console.log('groupIndex', groupIndex)

      if (groupIndex === -1) {
        this.tabsIndex = 'tab_wfl'
      } else {
        this.tabsIndex = 'tab_' + groupIndex
      }
      if (this.classIndex !== id) {
        this.classIndex = id
        this.$nextTick(() => {
          document.querySelector('#paper_' + id).scrollIntoView({behavior: 'smooth'})
          const sectionElement = document.getElementById('paper_' + id);
          const yOffset = 0; // 往下偏移量（自定义值）

          if (sectionElement) {
            const y = sectionElement.offsetTop - 70;

            window.scrollTo({top: y, behavior: 'smooth'});
          }
        })

      } else {
        this.classIndex = id
        this.$nextTick(() => {
          document.querySelector('#paper_' + id).scrollIntoView({behavior: 'smooth'})
          const sectionElement = document.getElementById('paper_' + id);
          const yOffset = 0; // 往下偏移量（自定义值）

          if (sectionElement) {
            const y = sectionElement.offsetTop - 70;

            window.scrollTo({top: y, behavior: 'smooth'});
          }
        })
        this.classIndex = -1
      }
      console.log('classIndex', this.classIndex)
    },
    showVideoPerview(key, index) {
      console.log('key', key);
      console.log('index', index);

      this.show2 = true


      this.$nextTick(() => {
        this.videoUrl = this.baseApi + '/' + index
      })


    },
    showImagePerview(key, index) {
      let data = []
      data.push(this.baseApi + '/' + this.formValidate[key].images[index])
      ImagePreview({
        images: data,
        startPosition: 0,
        showIndex: true,    //是否显示页码         默认 true
        showIndicators: true, //是否显示轮播指示器 默认 false
        loop: false,            //是否开启循环播放  貌似循环播放是不起作用的。。。
        closeOnPopstate: true,
        onClose: function (url) {  //回调参数,官方文档解释的不是很清楚。。。
          //回调参数类型 url:{ index:Number(当前图片的索引值), url:当前图片的URL }
          var num = url.index, url_link = url.url;
          console.log(url);
        }
      });
    },
    deleteVideoFile(key, _index) {


      // on confirm
      console.log('key', key)
      console.log('index', _index)


      this.formValidate[key].videos = this.formValidate[key].videos.filter(function (value, index, array) {
        console.log('is', index)
        return index !== _index;
      });
      console.log('this.formValidate[key].videos', this.formValidate[key].videos)


    },
    deleteImageFile(key, _index) {

      // on confirm
      console.log('key', key)
      console.log('index', _index)
      this.formValidate[key].images = this.formValidate[key].images.filter(function (value, index, array) {
        return index !== _index;
      });
      console.log('this.formValidate[key].images', this.formValidate[key].images)


    },
    showModal() {
      console.log('showModal')
      if (this.show) {
        this.show = false
      } else {
        this.show = true
      }
    },
    backTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动
      });
    },
    tabsChange(t) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动
      });
      this.autoOpenLocationSignIn()
    },
    videoChange(t) {
      console.log('video', t)
      console.log('video', t.target.files)
      if (this.formValidate['PAPER_' + this.paperId].videos === undefined) {
        this.formValidate['PAPER_' + this.paperId].videos = []
      }
      for (let i = 0; i < t.target.files.length; i++) {
        upLoadFileCommon(t.target.files[i]).then(res => {
          this.formValidate['PAPER_' + this.paperId].videos.push(res)
        })

      }

      console.log('formValidate', this.formValidate['PAPER_' + this.paperId].videos)
    },


    //压缩图片
    async compressFile(file) {
      return new Promise((resolve, reject) => {
        new ImageCompressor(file, {
          quality: 0.6, //压缩质量
          checkOrientation: false, //图片翻转，默认为false
          success(result) {
            resolve(result);
          },
          error(e) {
            reject()
          }
        })
      })
    },

    // 将blob转化为file
    blobToFile(theBlob) {
      // 新建一个blob类型的临时文件，并且指定文件名
      var file = new File([theBlob], theBlob.name, {type: theBlob.type});
      console.log('压缩后的文件', file)
      return file;
    },

    imageChange(t) {

      var fileName = new Date().getTime() + ".jpeg";
      var file = this.dataURLtoFile(t,fileName)

      if (this.formValidate['PAPER_' + this.paperId].images === undefined) {
        this.formValidate['PAPER_' + this.paperId].images = []
      }
      // for (let i = 0; i < t.length; i++) {
        if (!this.imageLoadingShow) {
          this.imageLoadingShow = true
        }
        this.compressFile(file).then(res => {
          uploadfilecommonAddWaterMarking(this.blobToFile(file), null, this.pointName).then(res => {
            this.formValidate['PAPER_' + this.paperId].images.push(res)
            this.imageLoadingShow = false
            Notify({type: 'success', message: '上传成功!'});
            this.$emit('auto-on-tempSave', this.formValidate, this.recordingId)
          }).catch(err => {
            this.imageLoadingShow = false
            Notify({type: 'danger', message: '上传失败!'});
          })
        })



      this.$nextTick(() => {
        this.$previewRefresh()
      })


      console.log('fileImageData', this.fileImageData)
    },
    showVideo(id) {
      this.paperId = id
      console.log('refs', this.$refs)
      console.log('ref', this.$refs['fileVideoRef' + id])

      // this.$refs['fileVideoRef' + id][0].click()
      wx.chooseMedia({
        count: 9,
        mediaType: ['image','video'],
        sourceType: ['album', 'camera'],
        maxDuration: 30,
        camera: 'back',
        success(res) {
          alert(res.tempFiles.tempFilePath)
          alert(res.tempFiles.size)
        }
      })
    },
      showImage(id) {
      let _this = this;
      this.paperId = id
       /*let baseData = 'data:image/jpeg;base64,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'
       var fileName = new Date().getTime() + ".jpg";
       let file = this.dataURLtoFile(baseData,fileName)
       console.log('file',file)*/
      var url = (window.location.href).split('#')[0];
      console.log(url)
       $.get('/weixin/initWXJSSDKConfigInfo?url=' + url).then(res => {
        var msg = '';
        if (res.data.success) {
          console.log('wx-res', res.data)
          msg = JSON.parse(res.data.msg);
          console.log('wxres', msg.appid)
          console.log('wx', wx)
          // 通过config接口注入权限验证配置
          wx.config({
            // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            debug: false,
            appId: msg.appid,
            timestamp: msg.timestamp,
            nonceStr: msg.nonceStr,
            signature: msg.signature,
            /* ！！！切记到时候按需自己选择，参考文档填写 */
            jsApiList: ['checkJsApi', 'chooseImage','getLocalImgData']
          });
          console.log('wx', wx)

        }

      })
      wx.ready(function () {
        wx.checkJsApi({
          jsApiList: ['chooseImage','getLocalImgData'],
          success:  function (res) {
            wx.chooseImage({
              count: 9, // 默认9
              sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有'original', 'compressed'
              sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
              success:  function (res) {
                var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                // 获取base64
                for (let i = 0; i <localIds.length ; i++) {
                  wx.getLocalImgData({
                    localId: localIds[i],
                    success: function (res) {
                      var localData = res.localData; // localData是图片的base64数据，可以用img标签显示
                      if (localData.indexOf('data:image') != 0) {
                        localData = 'data:image/jpeg;base64,' + localData
                      }
                      _this.imageChange(localData)
                    }
                  })
                }

              }
            })
          }
        });
      })
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type: mime});
    },
    init() {
      this.$preview.on('close', () => {
        console.log('图片查看器被关闭')
      })
      // 添加图片查看器实例--this.$preview.self 注意：此实例仅在图片查看器被打开时生效
      this.$preview.on('imageLoadComplete', (e, item) => {
        console.log(this.$preview.self)  //此时this.$preview.self拥有原插件photoswipe文档中的所有方法和属性
      })
    },
    handleAvatarSuccess(res, file) {
      console.log('上传成功', file)
      console.log('res', res)
      console.log('formValidate', this.formValidate)
      this.dialogImageUrl = URL.createObjectURL(file.raw);
      this.$nextTick(() => {
        this.$previewRefresh()
      })

    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        Notify({type: 'danger', message: '上传头像图片只能是 JPG 格式!'});
      }
      if (!isLt2M) {
        Notify({type: 'danger', message: '上传头像图片大小不能超过 2MB!'});
      }
      return isJPG && isLt2M;
    },
    handleChange(file, fileList) {
      console.log('file', file)
      console.log('fileList', fileList)
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },

    initPaperTrueSet(paper) {

      switch (paper.subjectType) {
        case 'PAPER_TYPE_SINGLE':
          if (this.formValidate['PAPER_' + paper.id].data != undefined && this.formValidate['PAPER_' + paper.id].data != '' && this.formValidate['PAPER_' + paper.id].data != null) {
            this.paperTrue['paper' + paper.id] = true
          } else {
            this.paperTrue['paper' + paper.id] = false
          }
          break
        case 'PAPER_TYPE_MULTIPLE':
          if (this.formValidate['PAPER_' + paper.id].data.length > 0) {
            this.paperTrue['paper' + paper.id] = true
          } else {
            this.paperTrue['paper' + paper.id] = false
          }
          break
        case 'PAPER_TYPE_NUMBER_COMPLETION':
          let flag = false
          for (let i = 0; i < paper.options.length; i++) {
            if (this.formValidate['PAPER_' + paper.id].data[i] !== undefined && this.formValidate['PAPER_' + paper.id].data[i] !== '' && this.formValidate['PAPER_' + paper.id].data[i] !== null) {
              flag = true
            } else {
              flag = false
              break;
            }
          }
          if (paper.options.length != this.formValidate['PAPER_' + paper.id].data.length) {
            flag = false
          }

          this.paperTrue['paper' + paper.id] = flag
          break
        case 'PAPER_TYPE_MATRIX':
          let flag1 = false

          //矩阵
          for (let i = 0; i < this.formValidate['PAPER_' + paper.id].data.length; i++) {
            for (let j = 0; j < this.formValidate['PAPER_' + paper.id].data[i].length; j++) {
              if (this.formValidate['PAPER_' + paper.id].data[i][j]) {
                flag1 = true
              }
            }
          }

          this.paperTrue['paper' + paper.id] = flag1
          break
        case 'PAPER_TYPE_TEXT_COMPLETION':
          if(this.formValidate['PAPER_' + paper.id].data!=undefined&&this.formValidate['PAPER_' + paper.id].data!=''){
              flag1 = true
          }
          this.paperTrue['paper' + paper.id] = flag1
      }

    },


    paperTrueInit() {

      this.paperCount = 0
      this.paperTrueCount = 0

      for (let i = 0; i < this.currentGroupList.length; i++) {

        for (let j = 0; j < this.currentGroupList[i].paperList.length; j++) {
          if (this.paperLogic['logic_' + this.currentGroupList[i].paperList[j].id]) {
            this.paperCount++
            this.initPaperTrueSet(this.currentGroupList[i].paperList[j])
            if (this.paperTrue['paper' + this.currentGroupList[i].paperList[j].id]) {
              this.paperTrueCount++
            }

          }

        }
      }

      for (let i = 0; i < this.surplusPaperList.length; i++) {
        if (this.paperLogic['logic_' + this.surplusPaperList[i].id]) {
          this.paperCount++
          this.initPaperTrueSet(this.surplusPaperList[i])
          if (this.paperTrue['paper' + this.surplusPaperList[i].id]) {
            this.paperTrueCount++
          }


        }
      }


      console.log('paperCount', this.paperCount)
      console.log('paperTrueCount', this.paperTrueCount)

    },
    setData({
              currentGroupList,
              surplusPaperList,
              logicList,
              isHeader = true,
              answer = false,
              answerData,
              recordingId,
              taskPointDetailsId,
              type
            }) {
      this.paperLogic = []
      this.paperList = []
      this.answer = answer
      this.answerData = answerData
      this.taskPointDetailsId = taskPointDetailsId
      this.type = type
      if (currentGroupList && currentGroupList.length) {
        this.tabsIndex = 'tab_' + 0
        this.initFrom(currentGroupList, surplusPaperList)
        console.log(this.formValidate)
        console.log(this.ruleValidate)
      }
      this.initLogic(currentGroupList, surplusPaperList)
      this.initLogicHide(logicList)
      this.currentGroupList = currentGroupList
      this.surplusPaperList = surplusPaperList
      this.logicList = logicList
      this.isHeader = isHeader
      if (recordingId !== null && recordingId !== undefined) {
        this.recordingId = recordingId
      }
      if (answer) {
        this.initAnswerLogic(currentGroupList, surplusPaperList)
      }

      this.paperTrueInit()

    },
    initFrom(currentGroupList, surplusPaperList) {
      console.log('index', this.index)
      for (const group of currentGroupList) {
        for (const paper of group.paperList) {
          const paramName = 'PAPER_' + paper.id
          let paperData = {
            data: null,
            descriptionShow: false,
            description: '',
            images: [],
            videos: []
          }
          if (paper.subjectType === 'PAPER_TYPE_SINGLE') {
            paperData.data = null
          } else if (paper.subjectType === 'PAPER_TYPE_MULTIPLE') {
            paperData.data = []
          } else if (paper.subjectType === 'PAPER_TYPE_NUMBER_COMPLETION') {
            const arr = new Array(paper.options.length).fill('')
            paperData.data = arr
          } else if (paper.subjectType === 'PAPER_TYPE_MATRIX') {
            let arr = new Array(paper.rows.length * paper.columns.length).fill(false)
            arr = _.chunk(arr, paper.columns.length)
            paperData.data = arr
          } else if (paper.subjectType === 'PAPER_TYPE_TEXT_COMPLETION'){
            paperData.data = ''
          }
          if (this.answer) {
            paperData = this.answerData?.[paramName]
          }
          this.$set(this.formValidate, paramName, paperData)
          this.initRuleValidate(paramName, paper)
          this.paperList.push(paper)
        }
      }
      for (const paper of surplusPaperList) {
        const paramName = 'PAPER_' + paper.id
        let paperData = {
          data: null,
          descriptionShow: false,
          description: '',
          images: [],
          videos: []
        }
        if (paper.subjectType === 'PAPER_TYPE_SINGLE') {
          paperData.data = null
        } else if (paper.subjectType === 'PAPER_TYPE_MULTIPLE') {
          paperData.data = []
        } else if (paper.subjectType === 'PAPER_TYPE_NUMBER_COMPLETION') {
          const arr = new Array(paper.options.length).fill('')
          paperData.data = arr
        } else if (paper.subjectType === 'PAPER_TYPE_MATRIX') {
          let arr = new Array(paper.rows.length * paper.columns.length).fill(false)
          arr = _.chunk(arr, paper.columns.length)
          paperData.data = arr
        }
        if (this.answer) {
          paperData = this.answerData?.[paramName]
        }
        this.$set(this.formValidate, paramName, paperData)
        this.initRuleValidate(paramName, paper)
        this.paperList.push(paper)
      }
    },
    initRuleValidate(paramName, paper) {
      if (paper.isRequired === '1') {
        switch (paper.subjectType) {
          case 'PAPER_TYPE_SINGLE':
            this.$set(this.ruleValidate, paramName, [
              {
                type: 'object', required: true, fields: {
                  data: {required: true, type: 'number', message: '此题不能为空', trigger: 'blur'}
                }
              }
            ])
            break
          case 'PAPER_TYPE_MULTIPLE':
            this.$set(this.ruleValidate, paramName, [
              {
                type: 'object', required: true, fields: {
                  data: {required: true, type: 'array', message: '此题不能为空', trigger: 'blur'}
                }
              }
            ])
            break
          case 'PAPER_TYPE_NUMBER_COMPLETION':
            const fields = {}
            const options = paper.options

            console.log('options', paper.options)

            this.$set(this.ruleValidate, paramName, [
              {
                type: 'object', required: true, fields: {
                  data: {
                    validator(rule, value, callback, source, options) {
                      for (let i = 0; i < paper.options.length; i++) {
                        if (value[i] === undefined || value[i] === '' || value[i] === null) {
                          callback(new Error('填空' + (i + 1) + '不能为空'));
                        }
                      }

                      callback();
                    },
                    trigger: 'blur'
                  }
                }
              }
            ])
            break
          case 'PAPER_TYPE_MATRIX':
            this.$set(this.ruleValidate, paramName, [
              {
                type: 'object', required: true, fields: {
                  data: {
                    validator(rule, value, callback, source, options) {

                      if (value && value.length) {
                        value.forEach((item, index) => {
                          const temp = _.compact(item);
                          if (!temp.length) {
                            callback(new Error('第' + (index + 1) + '行不能为空'))
                          }
                        })
                      } else {
                        callback(new Error('此题不能为空'))
                      }
                      callback()
                    },
                    trigger: 'blur'
                  }
                }
              }
            ])
            break
            case 'PAPER_TYPE_TEXT_COMPLETION':
              this.$set(this.ruleValidate, paramName, [
                {type: 'object', required: true, fields: {
                    data: {required: true, message: '此题不能为空', trigger: 'blur'}
                  }
                }
              ])
              break
        }
      }
    },
    initLogic(currentGroupList, surplusPaperList) {
      let paperLogic = []
      for (const group of currentGroupList) {
        for (const paper of group.paperList) {
          paperLogic['logic_' + paper.id] = true
        }
      }
      for (const paper of surplusPaperList) {
        paperLogic['logic_' + paper.id] = true
      }
      this.paperLogic = paperLogic
    },
    initLogicHide(logicList) {
      let hidePaperIds = []
      for (let i = 0; i < logicList.length; i++) {
        hidePaperIds.push(logicList[i].controlIds)
      }
      hidePaperIds = _.uniq(_.flattenDeep(hidePaperIds))
      for (let i = 0; i < hidePaperIds.length; i++) {
        this.paperLogic['logic_' + hidePaperIds[i]] = false
      }
    },
    initAnswerLogic(currentGroupList, surplusPaperList) {
      for (const group of currentGroupList) {
        for (const paper of group.paperList) {
          const subjectType = paper.subjectType
          const paramName = 'PAPER_' + paper.id
          const data = this.formValidate[paramName].data
          if (subjectType === 'PAPER_TYPE_SINGLE' && data) {
            this.paperChange(paper, data)
          } else if (subjectType === 'PAPER_TYPE_MULTIPLE' && data && data.length) {

            this.paperChangeDX(paper, data)
          }
        }
      }
      for (const paper of surplusPaperList) {
        const subjectType = paper.subjectType
        const paramName = 'PAPER_' + paper.id
        const data = this.formValidate[paramName].data
        if (subjectType === 'PAPER_TYPE_SINGLE' && data) {
          this.paperChange(paper, data)
        } else if (subjectType === 'PAPER_TYPE_MULTIPLE' && data && data.length) {
          for (const id of data) {
            this.paperChangeDX(paper, id)
          }
        }
      }
    },
    paperChangeJZ(paper, $event) {
      console.log('paper', paper)
      console.log('data', this.formValidate['PAPER_' + paper.id].data)
      console.log('$event', $event)


      let flag = true


      this.formValidate['PAPER_' + paper.id].data.forEach((item, index) => {
        const temp = _.compact(item);
        if (!temp.length) {
          flag = false
        }
      })

      this.paperTrue['paper' + paper.id] = flag

      this.paperTrueCount = 0
      this.paperCount = 0
      for (let i = 0; i < this.currentGroupList.length; i++) {
        for (let j = 0; j < this.currentGroupList[i].paperList.length; j++) {
          if (this.paperLogic['logic_' + this.currentGroupList[i].paperList[j].id]) {
            this.paperCount++
            if (this.paperTrue['paper' + this.currentGroupList[i].paperList[j].id]) {
              this.paperTrueCount++
            }
          }
        }
      }

      for (let i = 0; i < this.surplusPaperList.length; i++) {
        if (this.paperLogic['logic_' + this.surplusPaperList[i].id]) {
          this.paperCount++
          if (this.paperTrue['paper' + this.surplusPaperList[i].id]) {
            this.paperTrueCount++
          }
        }
      }
      this.$emit('auto-on-tempSave', this.formValidate, this.recordingId)
    },
    paperChange(paper, $event) {
      console.log("触发")
      console.log('paper', paper)
      console.log('data', this.formValidate['PAPER_' + paper.id].data)
      if (this.formValidate['PAPER_' + paper.id].data != undefined && this.formValidate['PAPER_' + paper.id].data != null && this.formValidate['PAPER_' + paper.id].data != '') {
        this.paperTrue['paper' + paper.id] = true
      }
      console.log('$event', $event)
      // 单选
      const filterLogics = _.filter(this.logicList, {'mainId': paper.id})
      if (filterLogics && filterLogics.length) {
        for (const logic of filterLogics) {
          const controlType = logic.controlType
          const controlIds = logic.controlIds
          const optionId = logic.optionId
          for (let i = 0; i < controlIds.length; i++) {
            let isShow = true

            isShow = optionId === $event && controlType === 'show'
            this.paperLogic['logic_' + controlIds[i]] = isShow

            const controlPaper = this.paperList.find(item => item.id === controlIds[i])
            if (!isShow) {
              if (controlPaper.subjectType === 'PAPER_TYPE_SINGLE') {
                this.formValidate['PAPER_' + controlPaper.id].data = null
                this.paperChange(controlPaper, null)
              } else if (controlPaper.subjectType === 'PAPER_TYPE_MULTIPLE') {
                this.formValidate['PAPER_' + controlPaper.id].data = []
                this.paperChangeDX(controlPaper, null)
              } else if (controlPaper.subjectType === 'PAPER_TYPE_NUMBER_COMPLETION') {
                this.formValidate['PAPER_' + controlPaper.id].data = new Array(controlPaper.options.length).fill('')
              } else if (controlPaper.subjectType === 'PAPER_TYPE_MATRIX') {
                let arr = new Array(controlPaper.rows.length * controlPaper.columns.length).fill(false)
                arr = _.chunk(arr, controlPaper.columns.length)
                this.formValidate['PAPER_' + controlPaper.id].data = arr
              }else if (controlPaper.subjectType === 'PAPER_TYPE_TEXT_COMPLETION'){
                this.formValidate['PAPER_' + controlPaper.id].data = ''
              }

            }
          }
        }
      }
      console.log(filterLogics)
      console.log(paper, $event)
      this.paperCount = 0
      this.paperTrueCount = 0

      for (let i = 0; i < this.currentGroupList.length; i++) {
        for (let j = 0; j < this.currentGroupList[i].paperList.length; j++) {
          if (this.paperLogic['logic_' + this.currentGroupList[i].paperList[j].id]) {
            this.paperCount++
            if (this.paperTrue['paper' + this.currentGroupList[i].paperList[j].id]) {
              this.paperTrueCount++
            }
          }
        }
      }

      for (let i = 0; i < this.surplusPaperList.length; i++) {
        if (this.paperLogic['logic_' + this.surplusPaperList[i].id]) {
          this.paperCount++
          if (this.paperTrue['paper' + this.surplusPaperList[i].id]) {
            this.paperTrueCount++
          }
        }
      }
      this.$emit('auto-on-tempSave', this.formValidate, this.recordingId)
      console.log('count', this.paperCount)

    },
    paperChangeDX(paper, $event) {
      console.log('paper', paper)
      console.log('data', this.formValidate['PAPER_' + paper.id].data)

      const filterLogics = _.filter(this.logicList, {'mainId': paper.id})
      if (filterLogics && filterLogics.length) {
        for (const logic of filterLogics) {
          const controlType = logic.controlType
          const controlIds = logic.controlIds
          const optionId = logic.optionId
          for (let i = 0; i < controlIds.length; i++) {
            let isShow = false
            if ($event !== null) {

              isShow = $event.indexOf(optionId) >= 0 && controlType === 'show';
            }


            this.paperLogic['logic_' + controlIds[i]] = isShow

            const controlPaper = this.paperList.find(item => item.id === controlIds[i])
            if (!isShow) {
              if (controlPaper.subjectType === 'PAPER_TYPE_SINGLE') {
                this.formValidate['PAPER_' + controlPaper.id].data = null
                this.paperChange(controlPaper, null)
              } else if (controlPaper.subjectType === 'PAPER_TYPE_MULTIPLE') {
                this.formValidate['PAPER_' + controlPaper.id].data = []
                this.paperChangeDX(controlPaper, null)
              } else if (controlPaper.subjectType === 'PAPER_TYPE_NUMBER_COMPLETION') {
                this.formValidate['PAPER_' + controlPaper.id].data = new Array(controlPaper.options.length).fill('')
              } else if (controlPaper.subjectType === 'PAPER_TYPE_MATRIX') {
                let arr = new Array(controlPaper.rows.length * controlPaper.columns.length).fill(false)
                arr = _.chunk(arr, controlPaper.columns.length)
                this.formValidate['PAPER_' + controlPaper.id].data = arr
              }else if (controlPaper.subjectType === 'PAPER_TYPE_TEXT_COMPLETION'){
                this.formValidate['PAPER_' + controlPaper.id].data = ''
              }

            }
          }
        }
      }
      this.$forceUpdate()


      if (this.formValidate['PAPER_' + paper.id].data.length > 0) {
        this.paperTrue['paper' + paper.id] = true
      } else {
        this.paperTrue['paper' + paper.id] = false
      }

      this.paperTrueCount = 0
      this.paperCount = 0
      for (let i = 0; i < this.currentGroupList.length; i++) {
        for (let j = 0; j < this.currentGroupList[i].paperList.length; j++) {
          if (this.paperLogic['logic_' + this.currentGroupList[i].paperList[j].id]) {
            this.paperCount++
            if (this.paperTrue['paper' + this.currentGroupList[i].paperList[j].id]) {
              this.paperTrueCount++
            }
          }
        }
      }

      for (let i = 0; i < this.surplusPaperList.length; i++) {
        if (this.paperLogic['logic_' + this.surplusPaperList[i].id]) {
          this.paperCount++
          if (this.paperTrue['paper' + this.surplusPaperList[i].id]) {
            this.paperTrueCount++
          }
        }
      }
      this.$emit('auto-on-tempSave', this.formValidate, this.recordingId)

    },
    paperChangeSZTK(paper, $event) {
      console.log('paper', paper)
      console.log('data', this.formValidate['PAPER_' + paper.id].data)
      console.log('$event', $event)
      let flag = false
      for (let i = 0; i < paper.options.length; i++) {
        if (this.formValidate['PAPER_' + paper.id].data[i] !== undefined && this.formValidate['PAPER_' + paper.id].data[i] !== '' && this.formValidate['PAPER_' + paper.id].data[i] !== null) {
          flag = true
        } else {
          flag = false
          break;
        }
      }
      if (paper.options.length != this.formValidate['PAPER_' + paper.id].data.length) {
        flag = false
      }

      this.paperTrue['paper' + paper.id] = flag


      this.paperTrueCount = 0
      this.paperCount = 0
      for (let i = 0; i < this.currentGroupList.length; i++) {
        for (let j = 0; j < this.currentGroupList[i].paperList.length; j++) {
          if (this.paperLogic['logic_' + this.currentGroupList[i].paperList[j].id]) {
            this.paperCount++
            if (this.paperTrue['paper' + this.currentGroupList[i].paperList[j].id]) {
              this.paperTrueCount++
            }
          }
        }
      }

      for (let i = 0; i < this.surplusPaperList.length; i++) {
        if (this.paperLogic['logic_' + this.surplusPaperList[i].id]) {
          this.paperCount++
          if (this.paperTrue['paper' + this.surplusPaperList[i].id]) {
            this.paperTrueCount++
          }
        }
      }

      this.$emit('auto-on-tempSave', this.formValidate, this.recordingId)

    },
    addRemark(id) {
      const descriptionShow = this.formValidate['PAPER_' + id].descriptionShow
      this.formValidate['PAPER_' + id].descriptionShow = !descriptionShow
      this.$emit('auto-on-tempSave', this.formValidate, this.recordingId)
    },

    checkToPaperCard(paper) {


      if (paper.isRequired === '1') {
        switch (paper.subjectType) {
          case 'PAPER_TYPE_SINGLE':
            if (this.formValidate['PAPER_' + paper.id].data === null || this.formValidate['PAPER_' + paper.id].data === '') {
              console.log('单选题为空', paper)
              return false
            }
            break
          case 'PAPER_TYPE_MULTIPLE':
            if (this.formValidate['PAPER_' + paper.id].data === null || this.formValidate['PAPER_' + paper.id].data === '' || this.formValidate['PAPER_' + paper.id].data.length < 1) {
              console.log('多选题为空', paper)
              return false
            }
            break
          case 'PAPER_TYPE_NUMBER_COMPLETION':
            const fields = {}
            const options = paper.options

            console.log('options', paper.options)

            for (let i = 0; i < paper.options.length; i++) {
              if (this.formValidate['PAPER_' + paper.id].data[i] === undefined || this.formValidate['PAPER_' + paper.id].data[i] === '' || this.formValidate['PAPER_' + paper.id].data[i] === null) {
                console.log('数值填空题为空', paper)
                return false
              }
            }
            break
          case 'PAPER_TYPE_MATRIX':
            if (this.formValidate['PAPER_' + paper.id].data && this.formValidate['PAPER_' + paper.id].data.length) {
              let arr = _.flattenDeep(this.formValidate['PAPER_' + paper.id].data);
              arr = _.compact(arr);
              if (!arr.length) {
                console.log('矩阵题为空', paper)
                return false
              }
            } else {
              console.log('矩阵题为空', paper)
              return false
            }
            break

        }
      }

      return true;


    },
    handleSubmitTempRecordingIds() {
      if (this.recordingLoadingShow) {
        Notify({type: "warning", message: "正在上传中..."})
        return
      }
      if (this.tempRecordingId.split(',').length > 0) {
        Dialog.confirm({
          title: '确认提示',
          message: '确认是否提交？',
        })
          .then(() => {
            // on confirm

            if (this.recordingId !== '') {
              this.tempRecordingId = this.recordingId + ',' + this.tempRecordingId
            }
            let data = {
              taskPointDetailsId: this.taskPointDetailsId,
              recordingId: this.tempRecordingId
            }
            $.post('mobile/addRecording', data).then(res => {
              Notify({type: 'success', message: '提交成功!'})
              this.recordingId = this.tempRecordingId
              this.tempRecordingId = ''
              this.show6 = false
            })
          })
          .catch(() => {
            // on cancel
          });

      } else {
        Notify({type: 'warning', message: '请先上传录音!'})
      }
    },
    handleSubmit() {/*
          for (const key in this.formValidate) {
            const id = key.split('_')[1]
            const images = this.fileImageData['paperImages' + id]
            const videos = this.fileVideoData['paperVideos' + id]
            this.formValidate[key].images = images??[]
            this.formValidate[key].videos = videos??[]
          }*/

      console.log(this.formValidate)
      const missingLocationGroups = this.getMissingLocationSignInGroups()
      if (missingLocationGroups.length) {
        this.scrollToGroup(missingLocationGroups[0])
        Notify({type: 'warning', message: '请先完成定位签到'});
        return
      }
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          if (this.recordingLoadingShow) {
            Notify({type: 'warning', message: '正在上传中，请稍后提交'});
            return
          }
          Dialog.confirm({
            title: '确认提示',
            message: '请确定答题完成，是否提交？',
          })
            .then(() => {
              // on confirm
              this.$emit('on-submit', this.formValidate, this.recordingId, this.getRequiredVisibleLocationSignInGroups())
            })
            .catch(() => {
              // on cancel
            });

        } else {

          for (let i = 0; i < this.currentGroupList.length; i++) {
            for (let j = 0; j < this.currentGroupList[i].paperList.length; j++) {

              if (this.paperLogic['logic_' + this.currentGroupList[i].paperList[j].id]) {
                if (!this.checkToPaperCard(this.currentGroupList[i].paperList[j])) {
                  this.checkPaperId = '#paper_' + this.currentGroupList[i].paperList[j].id
                  this.tabsIndex = 'tab_' + i
                  console.log('i', i)
                  this.$nextTick(() => {
                    document.querySelector(this.checkPaperId).scrollIntoView({behavior: 'smooth'})
                    const sectionElement = document.getElementById('paper_' + this.currentGroupList[i].paperList[j].id);
                    const yOffset = 0; // 往下偏移量（自定义值）

                    if (sectionElement) {
                      const y = sectionElement.offsetTop - 70;

                      window.scrollTo({top: y, behavior: 'smooth'});
                    }
                  })
                  return;
                }
              }


            }
          }

          for (let i = 0; i < this.surplusPaperList.length; i++) {

            if (!this.checkToPaperCard(this.surplusPaperList[i])) {
              this.tabsIndex = 'tab_wfl'
              this.$nextTick(() => {
                document.querySelector(this.checkPaperId).scrollIntoView({behavior: 'smooth'})
                const sectionElement = document.getElementById('paper_' + this.surplusPaperList[i].id);
                const yOffset = 0; // 往下偏移量（自定义值）

                if (sectionElement) {
                  const y = sectionElement.offsetTop - 70;

                  window.scrollTo({top: y, behavior: 'smooth'});
                }
              })
              return;
            }
          }
          Notify({type: 'danger', message: '未完成答题'});
        }
      })
    },
    handleReset() {
      this.$refs.formValidate.resetFields();
    }
  },
  mounted() {
    videojs.addLanguage('zh-CN', {
      "You aborted the media playback": "视频播放被终止",
      "A network error caused the media download to fail part-way.": "网络错误导致视频下载中途失败。",
      "The media could not be loaded, either because the server or network failed or because the format is not supported.": "视频因格式不支持或者服务器或网络的问题无法加载。",
      "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "由于视频文件损坏或是该视频使用了你的浏览器不支持的功能，播放终止。",
      "No compatible source was found for this media.": "无法找到此视频兼容的源。",
    });
    this.init()
  }
}
</script>
<style lang="less" scoped>

/deep/ .van-tab {
  flex: none !important;
  padding: 0px 20px;
}

/deep/ .van-sticky--fixed {
  position: fixed;
  margin-top: 45px;
}

/deep/ .el-form-item__label {
  font-size: 30px;
  color: #000000
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409EFF;
  border-color: #409EFF;
}

/deep/ .el-checkbox__inner {
  font-size: 30px;
  width: 30px;
  height: 30px;
}

/deep/ .el-checkbox__label {
  font-size: 34px;
  color: #000000;
  line-height: 40px;
}

/deep/ .el-checkbox {
  height: 30px;
  display: block;
  margin-left: 50px;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #409EFF;
  background: #409EFF;
}

/deep/ .el-radio__inner {
  font-size: 30px;
  width: 30px;
  height: 30px;
  border: 0.1px solid #000000;
}

/deep/ .el-icon-plus:before {
  content: "\e6d9";
  position: relative;
  top: -14px;
}

/deep/ .el-button {
  width: 100%;
  height: 100%;
  font-size: 30px
}

/deep/ .el-radio__label {
  font-size: 34px;
  color: #000000;

}

/deep/ .el-checkbox__inner::after {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  content: "";
  border: 0rem solid #fff;
  border-left: 0;
  border-top: 0;
  height: 0rem;
  left: 0rem;
  position: absolute;
  top: 0rem;
  -webkit-transform: rotate(45deg) scaleY(0);
  transform: rotate(45deg) scaleY(0);
  width: 0rem;
  -webkit-transition: -webkit-transform 0.15s ease-in 0.05s;
  transition: -webkit-transform 0.15s ease-in 0.05s;
  transition: transform 0.15s ease-in 0.05s;
  transition: transform 0.15s ease-in 0.05s, -webkit-transform 0.15s ease-in 0.05s;
  -webkit-transform-origin: center;
  transform-origin: center;
}

/deep/ .el-radio__inner::after {
  width: 0rem;
  height: 0rem;
  border-radius: 100%;
  background-color: #FFF;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%) scale(0);
  transform: translate(-50%, -50%) scale(0);
  -webkit-transition: -webkit-transform .15s ease-in;
  transition: -webkit-transform .15s ease-in;
  transition: transform .15s ease-in;
  transition: transform .15s ease-in, -webkit-transform .15s ease-in;
}

/deep/ .el-radio-group {
  height: 50%;
  width: 100%;
  display: inline-block;

  .el-radio {
    height: 100%;
    width: 100%;
    text-align: left;
    display: block;
    margin-left: 0.3rem;
    white-space: break-spaces;
    margin-bottom: 0.1rem;
    line-height: 20px;
  }
}


/deep/ .el-checkbox-group {
  height: 50%;
  display: inline-block;
  width: 100%;


  .el-checkbox {
    height: 100%;
    width: 100%;
    text-align: left;
    display: inline-block;
    margin-left: 0.3rem;
    margin-bottom: 0.1rem;
  }
}


/deep/ .van-tab--active {
  color: #323233;
  font-weight: bold;
  font-size: 14px;
  border-bottom: 1px solid;
}

/deep/ .el-input {
  font-size: 30px;
  color: #000000
}


//input text
/deep/.el-textarea__inner{
  font-size: 34px;
  min-height: 60px !important;
  height: 60px !important;
}
/deep/.el-textarea{
  height: 60px !important;
  min-height: 60px !important;
}

/deep/ .el-checkbox__label {
  display: inline-grid;
  white-space: break-spaces;
}

/deep/ .el-form-item__label::before {
  position: absolute;
  width: 2%;
  margin-top: 20px;
  text-indent: 10px;
}

/deep/ .el-scrollbar__bar {
  opacity: 1 !important;
}

/deep/ .el-form-item__error {
  font-size: 0.4rem !important;
}


</style>
<style lang="scss" scoped>
@import "../../../assets/css/question/preview";

::v-deep .ivu-form-item-content {
  line-height: unset !important;
}

:target {
  padding-top: 140px; // 这里需要根据实际情况进行调整
  margin-top: -80px;
  display: block;
}

a:link {
  text-decoration: none; /* 去除下划线 */
  cursor: pointer; /* 修改鼠标指针形状 */
}

a:hover {
  color: black; /* 设置鼠标悬停状态时的颜色 */
}

.paper-true {
  background-color: #07C160;
  font-size: 20px;
  color: #FFFFFF
}

.paper-false {
  background-color: #ee0a24;
  font-size: 20px;
  color: #fff;
}
.paper-true1 {
  font-size: 20px;
  color: #FFFFFF
}

.paper-false1 {
  font-size: 20px;
  color: #fff;
}

.vjs-big-play-button {
  left: 50% !important;
  top: 50% !important;
  margin-top: -1em;
  margin-left: -1.5em;
}

.video-js .vjs-big-play-button {
  border: unset !important;
  background-color: unset !important;
}

.video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  font-size: 45px;
}

.vjs-poster {
  background-size: 100% 100% !important;
}


.question-title {
  text-align: center;
  color: rgba(0, 82, 217, 1);
}

.tab-box {
  padding: 10px 20px;
}

.paper-box {
  margin-top: 30px;
  padding-top: 10px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 0.01rem;
  border-radius: 16px;
  background: #FFFFFF;
  box-shadow: 0px 6px 30px -32px #E7E8EC;

}

.paper-box1 {
  margin-top: 30px;
  padding-top: 10px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 1rem;
  border-radius: 16px;
  background: #FFFFFF;
  box-shadow: 0px 6px 30px -32px #E7E8EC;

}

.location-sign-btn {
  position: fixed;
  right: 10PX;
  bottom: 230PX;
  z-index: 500;
  width: 46PX;
  height: 46PX;
  border: 0;
  border-radius: 50%;
  background: #4263eb;
  box-shadow: 0 6PX 18PX rgba(66, 99, 235, 0.38);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.location-sign-badge {
  position: absolute;
  right: -3px;
  top: -3px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: #ee0a24;
  color: #ffffff;
  font-size: 11px;
  line-height: 16px;
}

.paper-input-number {
  width: 80px;

  ::v-deep .ivu-input {
    border-radius: 0;
    border-bottom: 1px solid;
    border-top: unset;
    border-left: unset;
    border-right: unset;

    &:hover {
      border-color: unset !important;
    }
  }


}

::v-deep .ivu-form-item-error {
  .paper-input-number {
    width: 80px;

    .ivu-input {
      border-bottom: 1px solid #ed4014;
    }
  }
}
::v-deep .el-form-item__label{
  width: 100%;
}
</style>
